export default __webpack_public_path__ + "static/media/overline~XfpiPyno.895ef1fc.svg";